document.addEventListener("rebuy:cart.change", function (event) {
  const cartCount = document.querySelectorAll("[data-cart-count]")
  cartCount.forEach((el) => (el.innerText = event.detail.cart.cart.item_count))

  const onlyHasSubProducts = event.detail.cart.cart.items.every(
    (item) => item?.selling_plan_allocation
  )
  const shippingBar = document.querySelector("ig-shipping-progress-container")
  if (shippingBar) {
    if (onlyHasSubProducts) {
      shippingBar.classList.add("is-hidden")
    } else {
      shippingBar.classList.remove("is-hidden")
    }
  }
})

const addWidthHeightToImage = (widget, width, height) => {
  const container = document.querySelector(`#rebuy-widget-${widget.id}`)
  if (!container) return
  const images = container.querySelectorAll(".rebuy-product-image img")
  images.forEach((image) => {
    image.setAttribute("width", width)
    image.setAttribute("height", height)
  })
}

const smartCartTopBannerSlider = () => {
  new Swiper(".cart-top-banner--container", {
    spaceBetween: 0,
    slidesPerView: "auto",
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
  })
}

document.addEventListener("rebuy:smartcart.show", function () {
  if (window.localization.market.handle !== "us") {
    setTimeout(() => {
      smartCartTopBannerSlider()
    }, 1000)
  }
})
